import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PrimeIcons } from 'primereact/api';

const TABS = [
  { to: '/', labelKey: 'navbar.dashboard', icon: PrimeIcons.HOME },
  { to: '/invoices', labelKey: 'navbar.invoices', icon: PrimeIcons.BOOK },
  { to: '/clients', labelKey: 'navbar.clients', icon: PrimeIcons.BUILDING },
  { to: '/documents', labelKey: 'navbar.documents', icon: PrimeIcons.FILE },
  { to: '/edit-profile', labelKey: 'navbar.settings', icon: PrimeIcons.COG },
];

const isTabActive = (pathname: string, to: string) =>
  to === '/' ? pathname === '/' : pathname.startsWith(to);

export const MobileTabBar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav
      aria-label={t('navbar.sections') as string}
      className="lg:hidden fixed bottom-0 left-0 right-0 z-[99998] bg-white border-t border-[#EAECEF] inset-b-safe shadow-[0_-1px_12px_rgba(46,67,95,0.06)]"
    >
      <ul className="flex items-stretch h-[64px]">
        {TABS.map((tab) => {
          const active = isTabActive(location.pathname, tab.to);
          return (
            <li key={tab.to} className="flex-1">
              <button
                type="button"
                onClick={() => navigate(tab.to)}
                aria-current={active ? 'page' : undefined}
                className={`relative w-full h-full flex flex-col items-center justify-center gap-[3px] px-1 transition-colors ${
                  active ? 'text-[#FF6F61]' : 'text-[#828E9F]'
                }`}
              >
                <span
                  aria-hidden="true"
                  className={`absolute top-0 h-[3px] w-8 rounded-b-full transition-opacity ${
                    active ? 'bg-[#FF6F61] opacity-100' : 'opacity-0'
                  }`}
                />
                <i className={tab.icon} style={{ fontSize: '1.15rem' }} />
                <span className="text-[10px] leading-[12px] font-[600] tracking-[0.01em] text-center">
                  {t(tab.labelKey)}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
